import { useEffect, useRef, useState } from "react";

/**
 * Custom select used in the Create Class modal so the options panel always
 * opens below the trigger with a capped, scrollable height (native <select>
 * dropdowns can't be constrained via CSS).
 * Keeps a hidden input with the given `id` so existing DOM-based payload reads
 * continue to work.
 */
const CreateClassSelect = ({
  id,
  value,
  onChange,
  options,
  ariaLabel,
  placeholder = "Select",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const selected = options.find((o) => String(o.value) === String(value));

  return (
    <div className="create-class-modal-select-dropdown" ref={ref}>
      <input type="hidden" id={id} value={value ?? ""} readOnly />
      <button
        type="button"
        className="create-class-modal-select-trigger"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={ariaLabel}
        onClick={() => setOpen((o) => !o)}
      >
        <span
          className={
            selected ? "" : "create-class-modal-select-trigger-placeholder"
          }
        >
          {selected ? selected.label : placeholder}
        </span>
        <img
          src="/img/new-icons/chevron-down.svg"
          alt=""
          className="create-class-modal-select-trigger-chevron"
          aria-hidden
        />
      </button>
      {open && (
        <div className="create-class-modal-select-panel" role="listbox">
          {options.map((o) => {
            const isSel = String(o.value) === String(value);
            return (
              <button
                key={o.value}
                type="button"
                role="option"
                aria-selected={isSel}
                className={
                  isSel
                    ? "create-class-modal-select-option is-selected"
                    : "create-class-modal-select-option"
                }
                onClick={() => {
                  onChange?.(String(o.value));
                  setOpen(false);
                }}
              >
                {o.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CreateClassSelect;
